import baseFilters from '@/app/dashboard/filters';
import { Icons } from '@/components/icons';
import {
  defaultStringFilter,
  type Filter,
} from '@/components/table-filters/constants';
import { SendOutConfig } from '@pigello/pigello-matrix';

export const sendOutFilters: Filter[] = [
  {
    ...defaultStringFilter,
    title: SendOutConfig.fields.customId.verboseName,
    externalFieldName: SendOutConfig.fields.customId.externalFieldName,
    icon: Icons.id,
  },
  ...baseFilters,
];
